import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=fd173d54&"
import script from "../../models/login-members/index.ts?vue&type=script&lang=ts&"
export * from "../../models/login-members/index.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports